import {Action} from '@ngrx/store';
import {type} from '../../shared';

export const mergeSubscriptionActionTypes = {
  MERGE: type('[Subscription] Merge'),
  MERGE_SUCCESS: type('[Subscription] Merge Success'),
  MERGE_FAIL: type('[Subscription] Merge Fail'),
  NEW_SITE_MERGE: type('[Subscription] New site Merge'),
  NEW_SITE_MERGE_SUCCESS: type('[Subscription] New site Merge Success'),
  NEW_SITE_MERGE_FAIL: type('[Subscription] New site Merge Fail'),
};

export class MergeSubscriptionAction implements Action {
  readonly type = mergeSubscriptionActionTypes.MERGE;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any ) {}
}

export class MergeSubscriptionSuccessAction implements Action {
  readonly type = mergeSubscriptionActionTypes.MERGE_SUCCESS;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}

export class MergeSubscriptionFailAction implements Action {
  readonly type = mergeSubscriptionActionTypes.MERGE_FAIL;
  constructor(public payload?: string) {}
}

export class MergeSubscriptionNewSiteAction implements Action {
  readonly type = mergeSubscriptionActionTypes.NEW_SITE_MERGE;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any ) {}
}

export class MergeSubscriptionNewSiteSuccessAction implements Action {
  readonly type = mergeSubscriptionActionTypes.NEW_SITE_MERGE_SUCCESS;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}

export class MergeSubscriptionNewSiteFailAction implements Action {
  readonly type = mergeSubscriptionActionTypes.NEW_SITE_MERGE_FAIL;
  constructor(public payload?: string) {}
}
